import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';

export const usePalette = createGlobalState(() => {
  const palette = ref('dusk');

  return palette;
});
